import { useEffect, useState } from 'react';

import copy from "copy-to-clipboard"
import { cloneDeep } from 'lodash';
import { ContextItem } from 'twyne-new.ui';

import { useColors } from '@/components/builder/utils/tailwindConfig/hooks';

import { ContextMenuPopover } from '../../components/tailwindSandbox';

import AddPopover from './AddPopover';
import { usePalette } from './context';

function ContextMenu() {
  const { onCloseContextMenu, palette: { rightClick: { mouse = {}, color, custom, index } } } = usePalette()
  const { value: customColors, setValue: setCustomColors } = useColors()
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    setCopied(false)
  }, [color])

  const handleDelete = () => {
    const newColors = customColors.filter(item => color.rgbaParsed !== item.rgbaParsed)
    setCustomColors(newColors)
    onCloseContextMenu()
  }

  const handleEdit = newColor => {
    const newColors = cloneDeep(customColors)
    newColors[index] = newColor
    setCustomColors(newColors)
    onCloseContextMenu()
  }

  const handleDuplicate = () => {
    const newColors = [...customColors, { ...color, name: undefined }]
    setCustomColors(newColors)
    onCloseContextMenu()
  }

  const handleCopyHex = e => {
    e.preventDefault()
    e.stopPropagation()
    copy(color.hex)

    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 3000)
  }

  const options = [
    {
      label: 'Edit',
      component: <AddPopover
        color={color}
        editing
        trigger={<button disabled={!custom}><ContextItem disabled={!custom}>Edit</ContextItem></button>}
        onSubmit={handleEdit}
      />,
    },
    {
      label: 'Delete',
      onClick: handleDelete,
      disabled: !custom,
    },
    {
      label: 'Duplicate',
      onClick: handleDuplicate,
      disabled: false,
    },
    {
      label: copied ? 'Copied ✓' : 'Copy hex',
      onClick: handleCopyHex,
      disabled: false,
      closeOnClick: false,
    },
  ]

  return <ContextMenuPopover
    selected={color}
    options={options}
    mouse={{ left: mouse.x + 15, top: mouse.y + 25 }}
  />
}

export default ContextMenu
